export default {
  data() {
    const crown = require('../assets/icons/crown.svg')
    const leaf = require('../assets/icons/leaf.svg')
    const cross = require('../assets/icons/cross.svg')
    const presse = require('../assets/icons/presse.svg')

    return {
      current: new Date(),
      networks: ['facebook', 'instagram', 'linkedin', 'twitter', 'youtube', 'facebook_story', 'instagram_story', 'blog', 'newsletter', 'presse'],
      icons: {
        twitter: ['fab', 'twitter'],
        instagram: ['fab', 'instagram'],
        linkedin: ['fab', 'linkedin-in'],
        facebook: ['fab', 'facebook-f'],
        youtube: ['fab', 'youtube'],
        facebook_story: ['fab', 'facebook-f'],
        instagram_story: ['fab', 'instagram'],
        blog: ['fas', 'blog'],
        planned: 'calendar-day',
        premium: crown,
        light: leaf,
        no_crea: cross,
        presse,
      },

    }
  },
  computed: {
    account_boxes() {
      const box_account_id = this.$root.box_account_id
      console.log('dsqlkjdqs', box_account_id)
      if (!this.$root.idea_boxes || !this.$root.idea_boxes[box_account_id]) return
      const client_boxes = this.$root.idea_boxes[box_account_id].filter(d => this.$route.query.archived || !d.archived)
      return client_boxes.map((v, k) => {
        const datum = JSON.parse(JSON.stringify(v))
        if (!this.account_ideas) return datum
        datum.ideas = this.account_ideas.filter((idea, key) => idea.box_id === k)
        return datum
      })
    },
    account_ideas() {
      const box_account_id = this.$root.box_account_id
      if (!this.$root.ideas || !this.$root.ideas[box_account_id]) return
      return this.$root.ideas[box_account_id].map(d => {
        d.status = this._get_status(d)
        return d
      })
    },
    status_count() {
      if (!this.account_ideas) return {}
      const count = this.account_ideas.vls().groupBy('status').map((v,k) => v.length)
      count.total = this.account_ideas.vls().length || 0
      return count
    },
    ideas_by_date() {
      if (!this.filtered_ideas) return {}
      return this.filtered_ideas.groupBy(d => new Date(d.date).format('%Y-%m-%d'))
    }
  },
  methods: {
    log_change(change, idea_id) {
      const timestamp = new Date().getTime()
      const box_account_id = this.$root.box_account_id
      const user_id = this.$root.user_id
      const data = { idea_id, change, box_account_id, user_id}
      set(`public.box_history.${box_account_id}.changes.${timestamp}`, data)
    },
    _get_status(idea) {
      if (!idea.post_id || idea.status === 'denied') return idea.status
      const publication_date = new Date(idea.publication_date)
      if (publication_date < new Date()) return 'published'
      return 'scheduled'
    },
    save_idea(data, callback) {
      const base_status = data.status
      // if (data.status) data.status = 'submitted'
      const save = () => {
        // this.log_change('idea_modified', data.id)
        return set(`public.ideas.${this.$root.box_account_id}.${data.id}`, data)
                .then(() => callback())
      }
      // if (base_status !== data.status) {
      //   const text = (base_status === 'draft') ? this.t.confirm_change_visible : this.t.confirm_change_draft
      //   return this.$root.confirm_modal = {
      //     text,
      //     confirm: save,
      //     cancel: () => {
      //       data.status = base_status
      //     }
      //   }
      // }
      return save()
    },
    change_idea(idea_id, key, value) {
      return set(`public.ideas.${this.$root.box_account_id}.${idea_id}.${key}`, value)
    },
    change_status(idea_id, status) {
      // this.log_change(status, idea_id)
      return set(`public.ideas.${this.$root.box_account_id}.${idea_id}.status`, status)
        .then(() => this.$root.modal = null)
    },
    new_comment(idea_id, text) {
      const comment_id = 'comment_' + new Date().getTime() + (''+Math.floor(Math.random() * 1000)).padLeft(4,'0')
      const date = new Date().toISOString()
      const comment = {
        date,
        text,
        author: this.$root.user.name,
      }
      // this.log_change('comment_created', idea_id)
      set(`public.ideas.${this.$root.box_account_id}.${idea_id}.comments.${comment_id}`, comment)
    },
    reply_comment(idea_id, comment_id, message) {
      const replies = this.$root.ideas[this.$root.box_account_id][idea_id].comments[comment_id].replies || []
      const date = new Date().toISOString()
      const reply = {
        date,
        message,
        author: this.$root.user.name,
      }
      replies.push(reply)
      // this.log_change('comment_reply', idea_id)
      set(`public.ideas.${this.$root.box_account_id}.${idea_id}.comments.${comment_id}.replies`, replies)

    },
    resolve_comment(idea_id, comment_id, previous_status) {
      const new_status = (previous_status === 'pending') ? 'resolved' : 'pending'
      // this.log_change('comment_resolved', idea_id)
      set(`public.ideas.${this.$root.box_account_id}.${idea_id}.comments.${comment_id}.status`, new_status)
    },
    new_box() {
      const id = 'box_' + new Date().getTime() + (''+Math.floor(Math.random() * 1000)).padLeft(4,'0')
      const data = { id, title: '', box_account_id: null }
      set(`public.idea_boxes.${this.$root.box_account_id}.${id}`, data)
          .then(() => {
            this.$nextTick(() => {
              const el = document.querySelector(`#${id} button.edit`)
              if (el) el.click()
            })
          })
    },
    save_box(data) {
      set(`public.idea_boxes.${this.$root.box_account_id}.${data.id}`, data)
    },
    archive_box(box_id, archive=true) {
      set(`public.idea_boxes.${this.$root.box_account_id}.${box_id}.archived`, archive)
    },
    link_calendar(box_id, account_id) {
      set(`public.idea_boxes.${this.$root.box_account_id}.${box_id}.linked_calendar`, account_id)
    },
    new_idea({ title, description, publication_date, box_id, images}) {
      // this.$root.modal = { name: 'new_idea' }
      const id = 'idea_' + new Date().getTime() + (''+Math.floor(Math.random() * 1000)).padLeft(4,'0')
      const data = {
          id,
          description,
          title,
          box_id,
          status: 'submitted',
          date_created: new Date().toISOString(),
          publication_date,
          created_by: this.$root.user.name || this.$root.user.email,
          images,
          author_id: this.$root.user_id,
        }
        this.log_change('idea_created', id)
        return set(`public.ideas.${this.$root.box_account_id}.${id}`, data)
    },
    change_box(idea_id, box_id) {
      return set(`public.ideas.${this.$root.box_account_id}.${idea_id}.box_id`, box_id)
    },
    delete_idea(idea_id) {
      const conf = confirm('Etes-vous sûr ? Cette action est irréversible')
      if (!conf) return
      return set(`public.ideas.${this.$root.box_account_id}.${idea_id}`, null)
    },
    clone_idea(data) {
      // console.log('clonse',data)
      const id = 'idea_' + new Date().getTime() + (''+Math.floor(Math.random() * 1000)).padLeft(4,'0')
      data.id = id
      data.title = data.title + " (Copy)"
      this.log_change('idea_created', id)
      set(`public.ideas.${this.$root.box_account_id}.${id}`, data)
    },
    multiple_file_upload(ev, idea_id) {
      const files = ev.target.files
      if (idea_id) return files.reduce((acc, v) => acc.then(() => this.file_upload(v, idea_id)), Promise.resolve())
      const images = []
      return files.reduce((acc, v) => acc.then(() => this.temp_file_upload(v).then((path) => images.push(path))), Promise.resolve())
                    .then(() => images)
    },
    file_upload(file, idea_id) {
      const client_name = this.$root.box_account_id
      const path = `public/clients/${client_name}/${idea_id}/${file.name}`
      const ref = firebase.storage().ref().child(path)
      const images = this.$root.ideas[client_name][idea_id].images || []
      this.$root.uploading = true
      const instance = this
      return ref.put(file).then(function(snapshot) {
        return set(`public.ideas.${client_name}.${idea_id}.images`, images.concat(path))
          .then(() => instance.$root.uploading = false)
      })
    },
    temp_file_upload(file) {
      const client_name = this.$root.box_account_id
      const idea_id = 'temp_' + new Date().getTime() + (''+Math.floor(Math.random() * 1000)).padLeft(4,'0')
      const path = `public/clients/${client_name}/${idea_id}/${file.name}`
      const ref = firebase.storage().ref().child(path)
      this.$root.uploading = true
      const instance = this
      return ref.put(file).then(() => {
        this.$root.uploading = false
        return path
      })
    },
    new_post(account_id, { publication_date, description, title, images }) {
      const id = 'post_' + new Date().getTime() + (''+Math.floor(Math.random() * 1000)).padLeft(4,'0')
      const data = {
          id,
          text: description || '',
          title,
          networks: [],
          images: images || [],
          status: 'unconfirmed',
          sponsor_budget: 0,
          date: publication_date ? new Date(publication_date).beginningOfDay().toISOString() : new Date().beginningOfDay().toISOString(),
        }
        // this.log_change('post_created', id)
      return set(`public.posts.${account_id}.${id}`, data).then(() => id)
    },
    thumbnail_upload(ev, idea_id) {
      const client_name = this.$root.box_account_id
      const file = ev.target.files[0]
      const path = `public/clients/${client_name}/${file.name}`
      const ref = firebase.storage().ref().child(path)
      this.$root.uploading = true
      const instance = this
      return ref.put(file).then(function(snapshot) {
        return set(`public.ideas.${client_name}.${idea_id}.thumbnail`, path)
          .then(() => instance.$root.uploading = false)
      })
    },
    delete_video(path, idea_id) {
      const ref = firebase.storage().ref().child(path)
      const client_name = this.$root.box_account_id
      return ref.delete().then(snapshot => set(`public.ideas.${client_name}.${idea_id}.video`, null))
    },
    video_upload(ev, idea_id) {
      const file = ev.target.files[0];
      const client_name = this.$root.box_account_id
      const path = `public/clients/${client_name}/${file.name}`
      const ref = firebase.storage().ref().child(path)
      this.$root.uploading = true
      const instance = this
      return ref.put(file).then(function(snapshot) {
        return set(`public.ideas.${client_name}.${idea_id}.video`, path)
          .then(() => instance.$root.uploading = false)
      })
    },
    delete_image(idea_id, path) {
      const client_name = this.$root.box_account_id
      const images = this.$root.ideas[client_name][idea_id].images || []
      return set(`public.ideas.${client_name}.${idea_id}.images`, images.filter(d => d !== path))
                  .then(() => firebase.storage().ref(path).delete())
    },
  }
}
